import { IconAttributeTraveller } from '@components/icons/attribute-traveller';
import { IconTextLong } from '@components/icons/text-long';
import { TextField } from '@components/text-field';
import { TextArea } from '@components/textarea';
import { getScopedTranslate } from '@locale/translate';
import { asteriskLabel } from '@utils/strings';

import { FieldDropzone } from './field-dropzone';
import { useTextInputActions } from './use-field-actions';

import { conditionsTab } from '../conditions-tab';
import { useFormBuilderContext } from '../context';
import { FieldEdit } from '../field-edit';
import { FieldConfig } from '../field-registry';
import { FieldSidebarLabel } from '../fields-sidebar';
import { RequiredSwitch } from '../required-switch';

type Config = FieldConfig<'input-text-large'>;

const Display: Config['Display'] = ({ field }) => {
  return (
    <TextArea
      label={asteriskLabel(field.label, field.isRequired)}
      placeholder={field.placeholder}
      labelIcon={field.companyAttributeId ? <IconAttributeTraveller size={16} /> : undefined}
    />
  );
};

const FormBuilderTextLarge: Config['Component'] = ({ field, dragHandle }) => {
  const actions = useFormBuilderContext().store.actions;
  const menuItems = useTextInputActions(field);

  return (
    <FieldDropzone field={field}>
      <FieldEdit
        field={field}
        dragHandle={dragHandle}
        menu={menuItems}
        display={<Display field={field} />}
        edit={
          <>
            <TextField
              onChange={actions.createChangeHandler(field, 'label')}
              defaultValue={field.label}
              label={t('label')}
              maxChars={255}
            />
            <TextField
              onChange={actions.createChangeHandler(field, 'placeholder')}
              defaultValue={field.placeholder}
              label={t('placeholder')}
            />
            <RequiredSwitch field={field} />
          </>
        }
      />
    </FieldDropzone>
  );
};

const { t } = getScopedTranslate({
  en: {
    title: 'Long text',
    label: 'Label',
    placeholder: 'Placeholder text',
  },
});

export const textLargeField: Config = {
  kind: 'input-text-large',
  title: t('title'),
  group: 'inputs',
  propertiesTabs: [conditionsTab],
  Display,
  TreeDisplay: ({ field }) => <FieldSidebarLabel label={field.label} />,
  Icon: IconTextLong,
  Component: FormBuilderTextLarge,
};
